<template>
    <header class="main-layout__header">
        <div class="main-layout__container">
            <div class="main-header">
                <img
                    src="@/assets/icons/logo-big.svg"
                    class="main-header__logo"
                    @click="goToAuctionsListPage"
                />

                <HeaderNavigation />

                <div class="main-header__user-info">
                    <div class="user-info__details">
                        <span class="user-info__username">
                            {{ currentUser.full_name }}
                        </span>

                        <span class="user-info__role">{{ currentUser.is_admin ? 'Администратор' : currentUser.dealer_name }}</span>
                    </div>

                    <HeaderSettings />
                </div>
            </div>
        </div>
    </header>
</template>

<script lang="ts" setup>
    import { useRouter } from 'vue-router';

    import { injectStrict } from '@/injection/injectStrict';
    import { AuthKey } from '@/injection/keys';

    import { CurrentUser } from '@/types/user/users.type.ts';

    import HeaderNavigation from '@/layouts/MainLayout/components/HeaderNavigation/HeaderNavigation.vue';
    import HeaderSettings from '@/layouts/MainLayout/components/HeaderSettings/HeaderSettings.vue';

    const $Auth = injectStrict(AuthKey);

    const router = useRouter();

    const currentUser: CurrentUser = $Auth.getCurrentUser();

    const goToAuctionsListPage = (): void => {
        router.push({ name: 'AuctionsList' });
    };
</script>
